import { render, staticRenderFns } from "./SSO.vue?vue&type=template&id=f33c16ca&scoped=true"
import script from "./SSO.vue?vue&type=script&lang=js"
export * from "./SSO.vue?vue&type=script&lang=js"
import style0 from "./SSO.vue?vue&type=style&index=0&id=f33c16ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f33c16ca",
  null
  
)

export default component.exports